module.exports = __webpack_public_path__ + "img/eye-closed.0b14d5f3.svg";